import { render, staticRenderFns } from "./EchartsRadarChart.vue?vue&type=template&id=d8bf1bf6&"
import script from "./EchartsRadarChart.vue?vue&type=script&lang=js&"
export * from "./EchartsRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports